const { i18n } = require('@/locales');

/* eslint-disable */
(function (factory, window) {

  // define an AMD module that relies on 'leaflet'
  if (define !== undefined && typeof define === 'function' && define.amd) {
    define(['leaflet'], factory);

    // define a Common JS module that relies on 'leaflet'
  } else if (typeof exports === 'object') {
    module.exports = factory(require('leaflet'));
  }

  // attach your plugin to the global 'L' variable
  if (typeof window !== 'undefined' && window.L) {
    window.L.PostcodeLayer = factory(L);
    window.L.postcodeLayer = function() {
      return new window.L.PostcodeLayer()
    };
  }
}(function (L) {
  const MouseControlBox = L.Control.extend({
    options: {
      position: 'bottomright',
    },
    onAdd() {
      const boxes = [
        {text:i18n.t('Left-click for select'), icon: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTMuODA3IDguNzcxbDQuNzY4LTMuMzAyLTEuNDE1LTIuMDQyYy0uNjQ0LS45MjgtMS42NzgtMS40MjctMi43MjctMS40MjctLjY1MSAwLTEuMzA5LjE5MS0xLjg4NC41OWwtMi4wNDUgMS40MTUgMy4zMDMgNC43NjZ6bS01LjE4NCA1LjYwOWwzLjMwMiA0Ljc2N2MxLjI4NiAxLjg1NyAzLjM1MyAyLjg1MyA1LjQ1MiAyLjg1MyAzLjYyOCAwIDYuNjIzLTIuOTQ0IDYuNjIzLTYuNjM0IDAtMS4zMDItLjM4My0yLjYxNy0xLjE4MS0zLjc2OGwtMy4zMDEtNC43NjUtMTAuODk1IDcuNTQ3em0uNTItOS40MzFsLTIuMDQgMS40MTZjLTEuNTA2IDEuMDQyLTEuODgxIDMuMTA2LS44MzggNC42MWwxLjQxMyAyLjA0MyA0Ljc2OC0zLjMwMi0zLjMwMy00Ljc2N3ptLTEuNjQ2IDUuMTcxYy0uNTctLjgyMy0uMzY5LTEuOTQ4LjQ2MS0yLjUyMmwuODA3LS41NiAxLjU5MyAyLjI5OS0yLjMgMS41OTMtLjU2MS0uODF6bS0zLjMyMS0yLjIzMWwtMi40OTktMS43NC42Mi0uODkxIDIuMjcxIDEuNTgyYy0uMTY5LjMzMi0uMy42ODEtLjM5MiAxLjA0OXptLjcwMiA0LjAwNmwtMi4yOTkgMS42MTUtLjYyNC0uODg4IDIuNDE0LTEuNjk5Yy4xMzUuMzM4LjI5OS42NjUuNTA5Ljk3MnptLS43NzgtMS45MDZoLTMuMXYtMS4wODVoMy4wMjljLS4wMTMuMzY2LjAwNS43MjkuMDcxIDEuMDg1eiIvPjwvc3ZnPg=='},
        {text:i18n.t('Right-click for zoom'), icon: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNNi40MDcgNy4yNTJsLTIuMDA0IDEuMzljLS45MTMuNjMyLTEuNDAzIDEuNjQ3LTEuNDAzIDIuNjc5IDAgLjYzOS4xODggMS4yODQuNTggMS44NDlsMS4zODggMi4wMDcgNC42ODMtMy4yNDQtMy4yNDQtNC42ODF6bTYuNjQxLS42NGwuNTM1Ljc3Mi0yLjIxNiAxLjUzNS0xLjUzNS0yLjIxNS43NzUtLjUzNmMuOC0uNTU1IDEuODkyLS4zNSAyLjQ0MS40NDR6bS0xLjQ0NS0yLjI1N2MtLjYzOSAwLTEuMjg1LjE4OC0xLjg1LjU4bC0yLjAwOCAxLjM5IDMuMjQ0IDQuNjgyIDQuNjgzLTMuMjQzLTEuMzktMi4wMDVjLS42MzMtLjkxNC0xLjY0OC0xLjQwNC0yLjY3OS0xLjQwNHptLS40MjEtMS42MzVsLjAwMi0yLjcyIDEuMDc5LjAwMS0uMDAzIDIuNzM1Yy0uMjE3LS4wMjktLjQzNi0uMDQ3LS42NTgtLjA0N2wtLjQyLjAzMXptMi4xMTUuMjcybDEuNTc5LTIuMjUuODgzLjYyLTEuNDg4IDIuMTE5Yy0uMzA1LS4xOTctLjYzMS0uMzYzLS45NzQtLjQ4OXptLTQuMTkxLjM5NWwtMS40MjEtMi4wMzMuODg1LS42MTggMS41MyAyLjE5Yy0uMzQ3LjExMi0uNjc3LjI3My0uOTk0LjQ2MXptLTMuMjEgMTMuMTI4bDMuMjQzIDQuNjgzYzEuMjY0IDEuODIzIDMuMjk1IDIuODAyIDUuMzU2IDIuODAyIDMuNTYzIDAgNi41MDUtMi44OTMgNi41MDUtNi41MTcgMC0xLjI3OC0uMzc2LTIuNTctMS4xNi0zLjcwMWwtMy4yNDItNC42ODEtMTAuNzAyIDcuNDE0eiIvPjwvc3ZnPg=='},
      ];
      const container = L.DomUtil.create('div', 'leaflet-bar');
      container.style = 'background-color: white;padding: 10px';

      for (const i in boxes) {
        const {text, icon} = boxes[i];
        const box = L.DomUtil.create('div', '', container);
        box.style = 'display:inline-block;width:60px;margin:10px;text-align:center';
        const iconContainer = L.DomUtil.create('img', '', box);
        iconContainer.src = icon;
        iconContainer.style= 'display:block;width:20px;margin: 0 auto;';
        const textContainer = L.DomUtil.create('span', '', box);
        textContainer.innerText = text;
        if (i < boxes.length - 1) {
          const divider = L.DomUtil.create('div', '', container);
          divider.style = 'display:inline-block;width:1px;height:50px;border-right: 1px solid #bababa;margin: 0 5px';
        }
      }
      return container;
    },
  });

  return L.Layer.extend({
    options: {
      highlighedColor: '#a3d6b380',
      deactiveColor: '#f0f5e3',
      selectedColor: '#e1eac8',
      borderColor: '#bababa',
      baseColor: '#f0f5e3',
      areaUrl: 'https://postcode-map.s3-eu-west-1.amazonaws.com/GB',
      selectedRegions: new Set(),
      initialAreas: [],
    },
    map: null,
    currentRegionLayer: null,
    ukLayer: null,
    baseStyle: {},
    stripes: null,
    lastZoom: null,
    initialize: function (options) {
      options.selectedRegions = new Set(options.selectedRegions);
      this.baseStyle = {
        color: options.borderColor,
        fillColor: options.baseColor,
        fillOpacity: 1,
        weight: 1,
      }
      L.setOptions(this, options);
    },

    updateSelectedRegions(newRegions) {
      this.options.selectedRegions = new Set(newRegions);
      if (this.currentRegionLayer) {
        this.currentRegionLayer.eachLayer((l) => this.updateOutcodeStyle(l));
      }
      this.updateInitialAreas(this.options.initialAreas);
    },

    setLayerStyles() {
      this.ukLayer.eachLayer((l) => {
        l.setStyle({
          weight: (this.currentRegionLayer && this.currentRegionLayer.region === l.feature.properties.name) ? 5 : 1,
          fillColor: l.feature.properties.hasAllSelected ? this.options.selectedColor : this.options.deactiveColor,
          fillPattern: l.feature.properties.hasSomeSelected ? this.stripes : null,
        })
      });
    },

    updateInitialAreas(initialAreas) {
      this.options.initialAreas = initialAreas;
      for (const area of initialAreas) {
        const selectedCount = Array.from(this.options.selectedRegions)
          .filter((r) => r.slice(0, r.search(/\d/)) === area.area)
          .length;
        const allSelected = area.locations <= selectedCount;
        this.setRegionSelected(area.area, allSelected, !allSelected && (selectedCount > 0));
      }
      this.setLayerStyles();
    },

    loadRegion(region) {
      if (this.currentRegionLayer) {
        this.map.removeLayer(this.currentRegionLayer);
      }

      this.setLayerStyles();
      this.currentRegionLayer = new L.geoJson.ajax(`${this.options.areaUrl}/${region}.geojson`, {
        onEachFeature: (feature, layer) => {
          try {
            feature.properties.region = region;
            const regionName = feature.properties.name;
            layer.on('click', (e) => {
              this.map.fire(!this.options.selectedRegions.has(e.target.feature.properties.name) ? 'regionSelected' : 'regionDeselected', e.target);
            });
            layer.on('contextmenu', (e) => {
              this.map.removeLayer(this.currentRegionLayer);
              this.map.setZoom(this.lastZoom);
              this.currentRegionLayer = null;
              this.setLayerStyles();
              this.map.fire('areaClosed', {region: e.target.feature.properties.name});
            });
            layer.bindTooltip(regionName, {sticky: true});
            layer.setStyle({...this.baseStyle, fillColor: this.options.selectedRegions.has(regionName) ? this.options.selectedColor : this.baseStyle.fillColor});
          } catch (e) {
            console.error(e);
          }
        },
      });
      this.currentRegionLayer.region = region;
      this.currentRegionLayer.addTo(this.map);
      this.currentRegionLayer.on('data:loaded', (e) => {
        this.map.fitBounds(e.target.getBounds());
        this.map.fire('areaOpened', {region});
      });
    },

    onOutcodeSelected(layer, selected) {
      const regionName = layer.feature.properties.name;
      if (selected) {
        this.options.selectedRegions.add(regionName);
      } else {
        this.options.selectedRegions.delete(regionName);
      }
      this.updateOutcodeStyle(layer);

      const regionLayers = this.currentRegionLayer.getLayers();
      const selectedCount = regionLayers.filter((l) => this.options.selectedRegions.has(l.feature.properties.name)).length;
      const allSelected = regionLayers.length === selectedCount;
      this.setRegionSelected(layer.feature.properties.region, allSelected, !allSelected && (selectedCount > 0));
    },

    updateOutcodeStyle(layer) {
      if (this.options.selectedRegions.has(layer.feature.properties.name)) {
        layer.setStyle({fillColor: this.options.selectedColor});
      } else {
        layer.setStyle({fillColor: this.baseStyle.fillColor});
      }
    },

    selectRegion(region, selected = true) {
      let onEachFeature = (feature) => this.options.selectedRegions.add(feature.properties.name);
      if (!selected) {
        onEachFeature = (feature) => this.options.selectedRegions.delete(feature.properties.name);
      }

      L.geoJson.ajax(`${this.options.areaUrl}/${region}.geojson`, {onEachFeature});
      this.setRegionSelected(region, selected, false);
      this.map.fire(selected ? 'areaSelected' : 'areaDeselected', {region});
    },

    setRegionSelected(region, value, hasSomeSelected) {
      this.map.eachLayer((l) => {
        if (l.feature && l.feature.properties.name === region) {
          l.feature.properties.hasAllSelected = value;
          l.feature.properties.hasSomeSelected = hasSomeSelected;
        }
      });
    },

    onAdd: function (map, opts) {
      this.lastZoom = map.getZoom();
      this.map = map;

      this.stripes = new L.StripePattern({width: 8, weight: 4, spaceWeight:4, color: this.options.selectedColor, spaceColor: this.options.deactiveColor, spaceOpacity: 1});
      this.stripes.addTo(map);

      const mouseInfoBox = new MouseControlBox();
      mouseInfoBox.addTo(map);

      const selectedAreas = this.options.selectedRegions;

      this.ukLayer = new L.geoJson.ajax(`${this.options.areaUrl}/areas.json`, {
        onEachFeature: (feature, layer) => {
          const regionName = feature.properties.name;
          layer.on('click', (e) => {
            this.selectRegion(regionName, !feature.properties.hasAllSelected);
          });
          const areaSize = L.GeometryUtil.geodesicArea(
            feature.geometry.type === 'Polygon'
              ? layer.getLatLngs()[0]
              : layer.getLatLngs()[0][0]
          );
          layer.minZoom = 8 - Math.floor(Math.sqrt(areaSize / 100000000));
          layer.bindTooltip(regionName, {
            permanent: true,
            className: 'regionTooltip',
            direction:'center',
          });

          const area = this.options.initialAreas.find((area) => area.name === regionName);
          if (area) {
            const selectedCount = Array.from(this.options.selectedRegions)
              .filter((r) => r.slice(0, r.search(/\d/)) === regionName)
              .length;
            const allSelected = parseInt(area.regions) <= selectedCount;
            feature.properties.hasAllSelected = allSelected;
            feature.properties.hasSomeSelected = (!allSelected && (selectedCount > 0));
          }
        },
        style: this.baseStyle,
      });
      this.ukLayer.on('data:loaded', () => {
        toggleLabels();
        this.setLayerStyles();
      });
      this.ukLayer.on('mouseover', (e) => {
        e.layer.setStyle({fillColor: this.options.highlighedColor, fillPattern: null})
      });
      this.ukLayer.on('mouseout', (e) => {
        if (e.layer.feature.properties.hasAllSelected) {
          e.layer.setStyle({fillColor: this.options.selectedColor, fillPattern: null});
        } else if (e.layer.feature.properties.hasSomeSelected) {
          e.layer.setStyle({fillColor: this.options.selectedColor, fillPattern: this.stripes});
        } else {
          e.layer.setStyle({fillColor: this.options.deactiveColor, fillPattern: null});
        }
      });
      this.ukLayer.on('contextmenu', (e) => {
        e.layer.bringToFront();
        this.lastZoom = map.getZoom();
        this.loadRegion(e.layer.feature.properties.name);
        this.setLayerStyles();
      });
      this.ukLayer.addTo(map);


      map.on('zoomend', toggleLabels);
      map.on('regionSelected', (layer) => this.onOutcodeSelected(layer, true));
      map.on('regionDeselected', (layer) => this.onOutcodeSelected(layer, false));

      function toggleLabels() {
        const zoom = map.getZoom();
        map.eachLayer((layer) => {
          if (layer.minZoom) {
            if (layer.minZoom < zoom) {
              if (!layer.isTooltipOpen()) {
                map.addLayer(layer.getTooltip());
              }
            } else {
              map.closeTooltip(layer.getTooltip());
            }
          }
        });
      }
    }
  });
}, window));
